import { useEffect, useRef, useState } from 'react'
import '../styles/FadeInSection.modules.css'

export default function FadeInSection({ children, delay = 0 }) {
  const [isVisible, setVisible] = useState(false)
  const domRef = useRef()

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setVisible(true)
          }, delay)
        }
      })
    }, { threshold: 0.1 });
    
    const { current } = domRef;
    observer.observe(current);
    
    return () => observer.disconnect();
  }, [delay])

  return (
    <div 
      className={`fadeInSection ${isVisible ? 'isVisible' : ''}`} 
      ref={domRef}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  )
}